/* ============================================================
   JERKIN' IT v2.0 — COLLECTION
   Filters via the Section Rendering API: no full reload,
   scroll position kept, URL stays shareable.
   ============================================================ */
(() => {
  'use strict';
  if (window.__jiCollectionBound) return;
  window.__jiCollectionBound = true;

  const root = document.querySelector('[data-collection-root]');
  const form = document.querySelector('[data-collection-filters]');
  if (!root || !form) return;

  const sectionId = root.id.replace('JICollection-', '');
  let controller = null;

  async function apply(pushUrl = true) {
    const params = new URLSearchParams(new FormData(form));
    // Drop empty values so the URL stays clean and shareable.
    [...params.entries()].forEach(([k, v]) => { if (!v) params.delete(k); });
    const query = params.toString();
    const url = `${location.pathname}${query ? '?' + query : ''}`;

    root.setAttribute('aria-busy', 'true');
    controller?.abort();
    controller = new AbortController();
    try {
      const res = await fetch(`${url}${query ? '&' : '?'}section_id=${sectionId}`, { signal: controller.signal });
      if (!res.ok) throw new Error('Filter request failed');
      const html = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = html.querySelector('[data-collection-grid]');
      const current = root.querySelector('[data-collection-grid]');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      const freshPager = html.querySelector('.ji-pagination');
      const currentPager = root.querySelector('.ji-pagination');
      if (currentPager) currentPager.innerHTML = freshPager ? freshPager.innerHTML : '';
      if (pushUrl) history.replaceState({}, '', url);
    } catch (err) {
      if (err.name !== 'AbortError') location.href = url; // graceful degradation
    } finally {
      root.removeAttribute('aria-busy');
    }
  }

  form.addEventListener('change', (e) => {
    if (e.target.matches('input[type="checkbox"],[data-sort],input[type="number"]')) apply();
  });
  form.addEventListener('submit', (e) => { e.preventDefault(); apply(); });

  const toggle = document.querySelector('[data-filter-toggle]');
  toggle?.addEventListener('click', () => {
    const panel = document.querySelector('[data-filter-panel]');
    const open = panel?.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(!!open));
  });
})();
